@if (isLoading) {
  <div class="loader-overlay" role="status" aria-live="polite">
    <div class="heart-wrapper" aria-hidden="true">
      <svg class="heart-svg" viewBox="0 0 24 24">
        <path
          class="heart-shape"
          d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 6 4 4 6.5 4 8.24 4 9.91 5 10.54 6.36
             11.17 5 12.76 4 14.5 4 17 4 19 6 19 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
        />
        <polyline class="ekg" points="3 12 7 12 9 8 11 15 13 6 15 12 21 12" fill="none" />
      </svg>
    </div>
    <p class="loader-text mt-3 fw-semibold text-dark">Loading...</p>
  </div>
}

@if (!!patient && !isLoading) {
  <div class="booking-view-container container-fluid p-3 p-md-4">
    <!-- Hero Banner matching booking-view -->
    <div class="booking-hero card border-0 mb-4">
      <div class="booking-hero__content">
        <div>
          <div class="booking-hero__eyebrow">Patient File Overview</div>
          <h2 class="booking-hero__title mb-2">
            {{ patient.title ? patient.title + ' ' : '' }}{{ patient.firstName }}
            {{ patient.lastName }}
          </h2>
          <div class="booking-hero__meta">
            <span
              ><i class="bi bi-person-badge me-1"></i>Age:
              {{ patient.dateOfBirth ?? '' | age }} years</span
            >
            <span
              ><i class="bi bi-gender-ambiguous me-1"></i
              >{{ patient.gender || 'Not specified' }}</span
            >
            <span><i class="bi bi-envelope me-1"></i>{{ patient.email }}</span>
            <span><i class="bi bi-telephone me-1"></i>{{ patient.phoneNumber }}</span>
          </div>
        </div>

        <div class="booking-hero__status">
          @if (patient.clinicPatient?.status) {
            <span class="status-pill status-confirmed">{{ patient.clinicPatient?.status }}</span>
          }
          @if (patient.clinicPatient?.clinicPatientNumber) {
            <div class="booking-hero__status-note">
              <i class="bi bi-hash me-1"></i>ID: {{ patient.clinicPatient?.clinicPatientNumber }}
            </div>
          }
        </div>
      </div>
    </div>

    <div class="row g-4">
      <!-- LEFT PANEL: Personal Details -->
      <div class="col-12 col-xl-6">
        <div class="card booking-card h-100">
          <div class="card-header booking-card__header">
            <div>
              <div class="booking-card__eyebrow">Identity & Address</div>
              <h3 class="sub-title mb-0">Personal Details</h3>
            </div>
          </div>

          <div class="card-body p-0">
            <app-patient-personal-details [patient]="patient"></app-patient-personal-details>
          </div>
        </div>
      </div>

      <!-- RIGHT PANEL: File Summary + Health History -->
      <div class="col-12 col-xl-6 d-flex flex-column gap-4">
        <div class="card booking-card">
          <div class="card-header booking-card__header">
            <div>
              <div class="booking-card__eyebrow">Medical Overview</div>
              <h3 class="sub-title mb-0">File Summary</h3>
            </div>
          </div>

          <div class="card-body p-3">
            <app-patient-file-summary
              [booking]="patientAsAppointment"
              [emergencyContact]="emergencyContact"
            ></app-patient-file-summary>
          </div>
        </div>

        <app-patient-health-history [healthHistory]="healthHistory"></app-patient-health-history>
      </div>
    </div>

    <!-- CLINIC RECORD SECTION -->
    @if (patient.clinicPatient) {
      <div class="row mt-4">
        <div class="col-12">
          <div class="card booking-card">
            <div class="card-header booking-card__header">
              <div>
                <div class="booking-card__eyebrow">Practice System Record</div>
                <h3 class="sub-title mb-0">Membership Details</h3>
              </div>
            </div>
            <div class="card-body p-4">
              <div class="detail-matrix">
                @if (patient.clinicPatient.clinicPatientNumber) {
                  <div class="detail-chip">
                    <span class="detail-chip__label">Patient Number</span>
                    <span class="detail-chip__value">{{
                      patient.clinicPatient.clinicPatientNumber
                    }}</span>
                  </div>
                }

                @if (patient.clinicPatient.status) {
                  <div class="detail-chip">
                    <span class="detail-chip__label">Membership Status</span>
                    <span class="detail-chip__value text-success">{{
                      patient.clinicPatient.status
                    }}</span>
                  </div>
                }

                @if (patient.clinicPatient.employer) {
                  <div class="detail-chip">
                    <span class="detail-chip__label">Employer</span>
                    <span class="detail-chip__value">{{ patient.clinicPatient.employer }}</span>
                  </div>
                }

                @if (patient.clinicPatient.medicalAidScheme) {
                  <div class="detail-chip">
                    <span class="detail-chip__label">Medical Aid Scheme</span>
                    <span class="detail-chip__value">{{
                      patient.clinicPatient.medicalAidScheme
                    }}</span>
                  </div>
                }

                @if (patient.clinicPatient.medicalAidNumber) {
                  <div class="detail-chip">
                    <span class="detail-chip__label">Medical Aid Number</span>
                    <span class="detail-chip__value">{{
                      patient.clinicPatient.medicalAidNumber
                    }}</span>
                  </div>
                }

                @if (patient.clinicPatient.medicalAidPlan) {
                  <div class="detail-chip">
                    <span class="detail-chip__label">Medical Aid Plan</span>
                    <span class="detail-chip__value">{{
                      patient.clinicPatient.medicalAidPlan
                    }}</span>
                  </div>
                }

                @if (patient.clinicPatient.dateCreated) {
                  <div class="detail-chip">
                    <span class="detail-chip__label">Date Registered</span>
                    <span class="detail-chip__value">{{
                      patient.clinicPatient.dateCreated | date: 'dd MMM yyyy'
                    }}</span>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    }
  </div>
}
